import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { brandOpaqueBackgroundLogo, brandConstants } from 'brand-config';
import Header from '../header/header';
import SystemStatus from 'core/components/system-status';
import useSession from 'core/hooks/use-session';

import useStyles from './layout.styles';

const brand = brandConstants.SHORT_NAME?.toLowerCase();

const Layout = observer(({ children }) => {
  const session = useSession();
  const classes = useStyles({ showHeader: session.isLoggedIn, brand }) || {};

  return (
    <>
      {session.isLoggedIn ? (
        <Header />
      ) : (
        <img src={brandOpaqueBackgroundLogo} alt="gobranch" className={classes.logo} />
      )}
      <div className={classes.layout}>
        {session.isLoggedIn && <SystemStatus />}
        <div className={classes.container}>{children}</div>
      </div>
    </>
  );
});

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object
};

export default Layout;
